// list from https://documentation.identity.entrust.com/guide/supported-applicant-countries/
const countries = [
  { name: 'Afghanistan', alpha3: 'AFG', region: 'Asia', subregion: 'Southern Asia' },
  { name: 'Albania', alpha3: 'ALB', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Algeria', alpha3: 'DZA', region: 'Africa', subregion: 'Northern Africa' },
  { name: 'American Samoa', alpha3: 'ASM', region: 'Oceania', subregion: 'Polynesia', supportedIdentityReport: false },
  { name: 'Andorra', alpha3: 'AND', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Angola', alpha3: 'AGO', region: 'Africa', subregion: 'Middle Africa', supportedIdentityReport: false },
  { name: 'Anguilla', alpha3: 'AIA', region: 'Americas', subregion: 'Caribbean', supportedIdentityReport: false },
  { name: 'Antarctica', alpha3: 'ATA', region: '', subregion: '', supportedIdentityReport: false },
  {
    name: 'Antigua and Barbuda',
    alpha3: 'ATG',
    region: 'Americas',
    subregion: 'Caribbean',
  },
  { name: 'Argentina', alpha3: 'ARG', region: 'Americas', subregion: 'South America' },
  { name: 'Armenia', alpha3: 'ARM', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Aruba', alpha3: 'ABW', region: 'Americas', subregion: 'Caribbean' },
  {
    name: 'Australia',
    alpha3: 'AUS',
    region: 'Oceania',
    subregion: 'Australia and New Zealand',
  },
  { name: 'Austria', alpha3: 'AUT', region: 'Europe', subregion: 'Western Europe' },
  { name: 'Azerbaijan', alpha3: 'AZE', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Bahamas', alpha3: 'BHS', region: 'Americas', subregion: 'Caribbean', supportedIdentityReport: false },
  { name: 'Bahrain', alpha3: 'BHR', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Bangladesh', alpha3: 'BGD', region: 'Asia', subregion: 'Southern Asia', supportedIdentityReport: false },
  { name: 'Barbados', alpha3: 'BRB', region: 'Americas', subregion: 'Caribbean' },
  { name: 'Belarus', alpha3: 'BLR', region: 'Europe', subregion: 'Eastern Europe' },
  { name: 'Belgium', alpha3: 'BEL', region: 'Europe', subregion: 'Western Europe' },
  { name: 'Belize', alpha3: 'BLZ', region: 'Americas', subregion: 'Central America' },
  { name: 'Benin', alpha3: 'BEN', region: 'Africa', subregion: 'Western Africa' },
  { name: 'Bermuda', alpha3: 'BMU', region: 'Americas', subregion: 'Northern America' },
  { name: 'Bhutan', alpha3: 'BTN', region: 'Asia', subregion: 'Southern Asia' },
  {
    name: 'Bolivia (Plurinational State of)',
    alpha3: 'BOL',
    region: 'Americas',
    subregion: 'South America',
    supportedIdentityReport: false,
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    alpha3: 'BES',
    region: 'Americas',
    subregion: 'Caribbean',
    supportedIdentityReport: false,
  },
  {
    name: 'Bosnia and Herzegovina',
    alpha3: 'BIH',
    region: 'Europe',
    subregion: 'Southern Europe',
  },
  { name: 'Botswana', alpha3: 'BWA', region: 'Africa', subregion: 'Southern Africa', supportedIdentityReport: false },
  { name: 'Bouvet Island', alpha3: 'BVT', region: '', subregion: '', supportedIdentityReport: false },
  { name: 'Brazil', alpha3: 'BRA', region: 'Americas', subregion: 'South America' },
  {
    name: 'British Indian Ocean Territory',
    alpha3: 'IOT',
    region: 'Africa',
    subregion: 'Eastern Africa',
    supportedIdentityReport: false,
  },
  {
    name: 'Brunei Darussalam',
    alpha3: 'BRN',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
  },
  { name: 'Bulgaria', alpha3: 'BGR', region: 'Europe', subregion: 'Eastern Europe' },
  { name: 'Burkina Faso', alpha3: 'BFA', region: 'Africa', subregion: 'Western Africa' },
  { name: 'Burundi', alpha3: 'BDI', region: 'Africa', subregion: 'Eastern Africa' },
  { name: 'Cabo Verde', alpha3: 'CPV', region: 'Africa', subregion: 'Western Africa', supportedIdentityReport: false },
  { name: 'Cambodia', alpha3: 'KHM', region: 'Asia', subregion: 'South-Eastern Asia' },
  { name: 'Cameroon', alpha3: 'CMR', region: 'Africa', subregion: 'Middle Africa' },
  { name: 'Canada', alpha3: 'CAN', region: 'Americas', subregion: 'Northern America' },
  { name: 'Cayman Islands', alpha3: 'CYM', region: 'Americas', subregion: 'Caribbean' },
  {
    name: 'Central African Republic',
    alpha3: 'CAF',
    region: 'Africa',
    subregion: 'Middle Africa',
  },
  { name: 'Chad', alpha3: 'TCD', region: 'Africa', subregion: 'Middle Africa', supportedIdentityReport: false },
  { name: 'Chile', alpha3: 'CHL', region: 'Americas', subregion: 'South America' },
  { name: 'China', alpha3: 'CHN', region: 'Asia', subregion: 'Eastern Asia' },
  {
    name: 'Christmas Island',
    alpha3: 'CXR',
    region: 'Oceania',
    subregion: 'Australia and New Zealand',
    supportedIdentityReport: false,
  },
  {
    name: 'Cocos (Keeling) Islands',
    alpha3: 'CCK',
    region: 'Oceania',
    subregion: 'Australia and New Zealand',
    supportedIdentityReport: false,
  },
  { name: 'Colombia', alpha3: 'COL', region: 'Americas', subregion: 'South America' },
  { name: 'Comoros', alpha3: 'COM', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  { name: 'Congo', alpha3: 'COG', region: 'Africa', subregion: 'Middle Africa' },
  {
    name: 'Congo (Democratic Republic of the)',
    alpha3: 'COD',
    region: 'Africa',
    subregion: 'Middle Africa',
    supportedIdentityReport: false,
  },
  { name: 'Cook Islands', alpha3: 'COK', region: 'Oceania', subregion: 'Polynesia' },
  {
    name: 'Costa Rica',
    alpha3: 'CRI',
    region: 'Americas',
    subregion: 'Central America',
  },
  { name: 'Croatia', alpha3: 'HRV', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Cuba', alpha3: 'CUB', region: 'Americas', subregion: 'Caribbean' },
  { name: 'Curaçao', alpha3: 'CUW', region: 'Americas', subregion: 'Caribbean', supportedIdentityReport: false },
  { name: 'Cyprus', alpha3: 'CYP', region: 'Asia', subregion: 'Western Asia' },
  {
    name: 'Czech Republic',
    alpha3: 'CZE',
    region: 'Europe',
    subregion: 'Eastern Europe',
  },
  {
    name: "Côte d'Ivoire",
    alpha3: 'CIV',
    region: 'Africa',
    subregion: 'Western Africa',
  },
  { name: 'Denmark', alpha3: 'DNK', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Djibouti', alpha3: 'DJI', region: 'Africa', subregion: 'Eastern Africa' },
  { name: 'Dominica', alpha3: 'DMA', region: 'Americas', subregion: 'Caribbean' },
  {
    name: 'Dominican Republic',
    alpha3: 'DOM',
    region: 'Americas',
    subregion: 'Caribbean',
  },
  { name: 'Ecuador', alpha3: 'ECU', region: 'Americas', subregion: 'South America' },
  { name: 'Egypt', alpha3: 'EGY', region: 'Africa', subregion: 'Northern Africa' },
  {
    name: 'El Salvador',
    alpha3: 'SLV',
    region: 'Americas',
    subregion: 'Central America',
  },
  {
    name: 'Equatorial Guinea',
    alpha3: 'GNQ',
    region: 'Africa',
    subregion: 'Middle Africa',
  },
  { name: 'Eritrea', alpha3: 'ERI', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  { name: 'Estonia', alpha3: 'EST', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Ethiopia', alpha3: 'ETH', region: 'Africa', subregion: 'Eastern Africa' },
  {
    name: 'Falkland Islands (Malvinas)',
    alpha3: 'FLK',
    region: 'Americas',
    subregion: 'South America',
    supportedIdentityReport: false,
  },
  {
    name: 'Faroe Islands',
    alpha3: 'FRO',
    region: 'Europe',
    subregion: 'Northern Europe',
  },
  { name: 'Fiji', alpha3: 'FJI', region: 'Oceania', subregion: 'Melanesia' },
  { name: 'Finland', alpha3: 'FIN', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'France', alpha3: 'FRA', region: 'Europe', subregion: 'Western Europe' },
  {
    name: 'French Guiana',
    alpha3: 'GUF',
    region: 'Americas',
    subregion: 'South America',
    supportedIdentityReport: false,
  },
  {
    name: 'French Polynesia',
    alpha3: 'PYF',
    region: 'Oceania',
    subregion: 'Polynesia',
    supportedIdentityReport: false,
  },
  { name: 'French Southern Territories', alpha3: 'ATF', region: '', subregion: '', supportedIdentityReport: false },
  { name: 'Gabon', alpha3: 'GAB', region: 'Africa', subregion: 'Middle Africa' },
  { name: 'Gambia', alpha3: 'GMB', region: 'Africa', subregion: 'Western Africa', supportedIdentityReport: false },
  { name: 'Georgia', alpha3: 'GEO', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Germany', alpha3: 'DEU', region: 'Europe', subregion: 'Western Europe' },
  { name: 'Ghana', alpha3: 'GHA', region: 'Africa', subregion: 'Western Africa', supportedIdentityReport: false },
  { name: 'Gibraltar', alpha3: 'GIB', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Greece', alpha3: 'GRC', region: 'Europe', subregion: 'Southern Europe' },
  {
    name: 'Greenland',
    alpha3: 'GRL',
    region: 'Americas',
    subregion: 'Northern America',
    supportedIdentityReport: false,
  },
  { name: 'Grenada', alpha3: 'GRD', region: 'Americas', subregion: 'Caribbean' },
  { name: 'Guadeloupe', alpha3: 'GLP', region: 'Americas', subregion: 'Caribbean', supportedIdentityReport: false },
  { name: 'Guam', alpha3: 'GUM', region: 'Oceania', subregion: 'Micronesia', supportedIdentityReport: false },
  { name: 'Guatemala', alpha3: 'GTM', region: 'Americas', subregion: 'Central America' },
  { name: 'Guernsey', alpha3: 'GGY', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Guinea', alpha3: 'GIN', region: 'Africa', subregion: 'Western Africa' },
  {
    name: 'Guinea-Bissau',
    alpha3: 'GNB',
    region: 'Africa',
    subregion: 'Western Africa',
    supportedIdentityReport: false,
  },
  { name: 'Guyana', alpha3: 'GUY', region: 'Americas', subregion: 'South America', supportedIdentityReport: false },
  { name: 'Haiti', alpha3: 'HTI', region: 'Americas', subregion: 'Caribbean', supportedIdentityReport: false },
  {
    name: 'Heard Island and McDonald Islands',
    alpha3: 'HMD',
    region: '',
    subregion: '',
    supportedIdentityReport: false,
  },
  { name: 'Holy See', alpha3: 'VAT', region: 'Europe', subregion: 'Southern Europe', supportedIdentityReport: false },
  { name: 'Honduras', alpha3: 'HND', region: 'Americas', subregion: 'Central America' },
  { name: 'Hong Kong', alpha3: 'HKG', region: 'Asia', subregion: 'Eastern Asia' },
  { name: 'Hungary', alpha3: 'HUN', region: 'Europe', subregion: 'Eastern Europe' },
  { name: 'Iceland', alpha3: 'ISL', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'India', alpha3: 'IND', region: 'Asia', subregion: 'Southern Asia' },
  { name: 'Indonesia', alpha3: 'IDN', region: 'Asia', subregion: 'South-Eastern Asia' },
  {
    name: 'Iran (Islamic Republic of)',
    alpha3: 'IRN',
    region: 'Asia',
    subregion: 'Southern Asia',
  },
  { name: 'Iraq', alpha3: 'IRQ', region: 'Asia', subregion: 'Western Asia', supportedIdentityReport: false },
  { name: 'Ireland', alpha3: 'IRL', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Isle of Man', alpha3: 'IMN', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Israel', alpha3: 'ISR', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Italy', alpha3: 'ITA', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Jamaica', alpha3: 'JAM', region: 'Americas', subregion: 'Caribbean' },
  { name: 'Japan', alpha3: 'JPN', region: 'Asia', subregion: 'Eastern Asia' },
  { name: 'Jersey', alpha3: 'JEY', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Jordan', alpha3: 'JOR', region: 'Asia', subregion: 'Western Asia', supportedIdentityReport: false },
  { name: 'Kazakhstan', alpha3: 'KAZ', region: 'Asia', subregion: 'Central Asia' },
  { name: 'Kenya', alpha3: 'KEN', region: 'Africa', subregion: 'Eastern Africa' },
  { name: 'Kiribati', alpha3: 'KIR', region: 'Oceania', subregion: 'Micronesia', supportedIdentityReport: false },
  {
    name: "Korea (Democratic People's Republic of)",
    alpha3: 'PRK',
    region: 'Asia',
    subregion: 'Eastern Asia',
    supportedIdentityReport: false,
  },
  {
    name: 'Korea (Republic of)',
    alpha3: 'KOR',
    region: 'Asia',
    subregion: 'Eastern Asia',
  },
  { name: 'Kuwait', alpha3: 'KWT', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Kyrgyzstan', alpha3: 'KGZ', region: 'Asia', subregion: 'Central Asia' },
  {
    name: "Lao People's Democratic Republic",
    alpha3: 'LAO',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    supportedIdentityReport: false,
  },
  { name: 'Latvia', alpha3: 'LVA', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Lebanon', alpha3: 'LBN', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Lesotho', alpha3: 'LSO', region: 'Africa', subregion: 'Southern Africa' },
  { name: 'Liberia', alpha3: 'LBR', region: 'Africa', subregion: 'Western Africa', supportedIdentityReport: false },
  { name: 'Libya', alpha3: 'LBY', region: 'Africa', subregion: 'Northern Africa', supportedIdentityReport: false },
  {
    name: 'Liechtenstein',
    alpha3: 'LIE',
    region: 'Europe',
    subregion: 'Western Europe',
  },
  { name: 'Lithuania', alpha3: 'LTU', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Luxembourg', alpha3: 'LUX', region: 'Europe', subregion: 'Western Europe' },
  { name: 'Macao', alpha3: 'MAC', region: 'Asia', subregion: 'Eastern Asia', supportedIdentityReport: false },
  { name: 'Madagascar', alpha3: 'MDG', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  { name: 'Malawi', alpha3: 'MWI', region: 'Africa', subregion: 'Eastern Africa' },
  { name: 'Malaysia', alpha3: 'MYS', region: 'Asia', subregion: 'South-Eastern Asia' },
  { name: 'Maldives', alpha3: 'MDV', region: 'Asia', subregion: 'Southern Asia', supportedIdentityReport: false },
  { name: 'Mali', alpha3: 'MLI', region: 'Africa', subregion: 'Western Africa' },
  { name: 'Malta', alpha3: 'MLT', region: 'Europe', subregion: 'Southern Europe' },
  {
    name: 'Marshall Islands',
    alpha3: 'MHL',
    region: 'Oceania',
    subregion: 'Micronesia',
    supportedIdentityReport: false,
  },
  { name: 'Martinique', alpha3: 'MTQ', region: 'Americas', subregion: 'Caribbean', supportedIdentityReport: false },
  { name: 'Mauritania', alpha3: 'MRT', region: 'Africa', subregion: 'Western Africa' },
  { name: 'Mauritius', alpha3: 'MUS', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  { name: 'Mayotte', alpha3: 'MYT', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  { name: 'Mexico', alpha3: 'MEX', region: 'Americas', subregion: 'Central America' },
  {
    name: 'Micronesia (Federated States of)',
    alpha3: 'FSM',
    region: 'Oceania',
    subregion: 'Micronesia',
    supportedIdentityReport: false,
  },
  {
    name: 'Moldova (Republic of)',
    alpha3: 'MDA',
    region: 'Europe',
    subregion: 'Eastern Europe',
  },
  { name: 'Monaco', alpha3: 'MCO', region: 'Europe', subregion: 'Western Europe' },
  { name: 'Mongolia', alpha3: 'MNG', region: 'Asia', subregion: 'Eastern Asia', supportedIdentityReport: false },
  { name: 'Montenegro', alpha3: 'MNE', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Montserrat', alpha3: 'MSR', region: 'Americas', subregion: 'Caribbean' },
  { name: 'Morocco', alpha3: 'MAR', region: 'Africa', subregion: 'Northern Africa' },
  { name: 'Mozambique', alpha3: 'MOZ', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  { name: 'Myanmar', alpha3: 'MMR', region: 'Asia', subregion: 'South-Eastern Asia', supportedIdentityReport: false },
  { name: 'Namibia', alpha3: 'NAM', region: 'Africa', subregion: 'Southern Africa' },
  { name: 'Nauru', alpha3: 'NRU', region: 'Oceania', subregion: 'Micronesia', supportedIdentityReport: false },
  { name: 'Nepal', alpha3: 'NPL', region: 'Asia', subregion: 'Southern Asia' },
  { name: 'Netherlands', alpha3: 'NLD', region: 'Europe', subregion: 'Western Europe' },
  { name: 'New Caledonia', alpha3: 'NCL', region: 'Oceania', subregion: 'Melanesia', supportedIdentityReport: false },
  {
    name: 'New Zealand',
    alpha3: 'NZL',
    region: 'Oceania',
    subregion: 'Australia and New Zealand',
  },
  { name: 'Nicaragua', alpha3: 'NIC', region: 'Americas', subregion: 'Central America' },
  { name: 'Niger', alpha3: 'NER', region: 'Africa', subregion: 'Western Africa' },
  { name: 'Nigeria', alpha3: 'NGA', region: 'Africa', subregion: 'Western Africa' },
  { name: 'Niue', alpha3: 'NIU', region: 'Oceania', subregion: 'Polynesia', supportedIdentityReport: false },
  {
    name: 'Norfolk Island',
    alpha3: 'NFK',
    region: 'Oceania',
    subregion: 'Australia and New Zealand',
  },
  {
    name: 'North Macedonia',
    alpha3: 'MKD',
    region: 'Europe',
    subregion: 'Southern Europe',
    supportedIdentityReport: false,
  },
  {
    name: 'Northern Mariana Islands',
    alpha3: 'MNP',
    region: 'Oceania',
    subregion: 'Micronesia',
    supportedIdentityReport: false,
  },
  { name: 'Norway', alpha3: 'NOR', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Oman', alpha3: 'OMN', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Pakistan', alpha3: 'PAK', region: 'Asia', subregion: 'Southern Asia' },
  { name: 'Palau', alpha3: 'PLW', region: 'Oceania', subregion: 'Micronesia', supportedIdentityReport: false },
  {
    name: 'Palestine, State of',
    alpha3: 'PSE',
    region: 'Asia',
    subregion: 'Western Asia',
  },
  { name: 'Panama', alpha3: 'PAN', region: 'Americas', subregion: 'Central America' },
  {
    name: 'Papua New Guinea',
    alpha3: 'PNG',
    region: 'Oceania',
    subregion: 'Melanesia',
    supportedIdentityReport: false,
  },
  { name: 'Paraguay', alpha3: 'PRY', region: 'Americas', subregion: 'South America' },
  { name: 'Peru', alpha3: 'PER', region: 'Americas', subregion: 'South America' },
  {
    name: 'Philippines',
    alpha3: 'PHL',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
  },
  { name: 'Pitcairn', alpha3: 'PCN', region: 'Oceania', subregion: 'Polynesia', supportedIdentityReport: false },
  { name: 'Poland', alpha3: 'POL', region: 'Europe', subregion: 'Eastern Europe' },
  { name: 'Portugal', alpha3: 'PRT', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Puerto Rico', alpha3: 'PRI', region: 'Americas', subregion: 'Caribbean' },
  { name: 'Qatar', alpha3: 'QAT', region: 'Asia', subregion: 'Western Asia' },
  {
    name: 'Republic of Kosovo',
    alpha3: 'RKS',
    region: 'Europe',
    subregion: 'Southern Europe',
  },
  { name: 'Romania', alpha3: 'ROU', region: 'Europe', subregion: 'Eastern Europe' },
  {
    name: 'Russian Federation',
    alpha3: 'RUS',
    region: 'Europe',
    subregion: 'Eastern Europe',
  },
  { name: 'Rwanda', alpha3: 'RWA', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  { name: 'Réunion', alpha3: 'REU', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  {
    name: 'Saint Barthélemy',
    alpha3: 'BLM',
    region: 'Americas',
    subregion: 'Caribbean',
    supportedIdentityReport: false,
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha3: 'SHN',
    region: 'Africa',
    subregion: 'Western Africa',
    supportedIdentityReport: false,
  },
  {
    name: 'Saint Kitts and Nevis',
    alpha3: 'KNA',
    region: 'Americas',
    subregion: 'Caribbean',
  },
  { name: 'Saint Lucia', alpha3: 'LCA', region: 'Americas', subregion: 'Caribbean' },
  {
    name: 'Saint Martin (French part)',
    alpha3: 'MAF',
    region: 'Americas',
    subregion: 'Caribbean',
    supportedIdentityReport: false,
  },
  {
    name: 'Saint Pierre and Miquelon',
    alpha3: 'SPM',
    region: 'Americas',
    subregion: 'Northern America',
    supportedIdentityReport: false,
  },
  {
    name: 'Saint Vincent and the Grenadines',
    alpha3: 'VCT',
    region: 'Americas',
    subregion: 'Caribbean',
  },
  { name: 'Samoa', alpha3: 'WSM', region: 'Oceania', subregion: 'Polynesia' },
  { name: 'San Marino', alpha3: 'SMR', region: 'Europe', subregion: 'Southern Europe', supportedIdentityReport: false },
  {
    name: 'Sao Tome and Principe',
    alpha3: 'STP',
    region: 'Africa',
    subregion: 'Middle Africa',
    supportedIdentityReport: false,
  },
  { name: 'Saudi Arabia', alpha3: 'SAU', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Senegal', alpha3: 'SEN', region: 'Africa', subregion: 'Western Africa', supportedIdentityReport: false },
  { name: 'Serbia', alpha3: 'SRB', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Seychelles', alpha3: 'SYC', region: 'Africa', subregion: 'Eastern Africa', supportedIdentityReport: false },
  {
    name: 'Sierra Leone',
    alpha3: 'SLE',
    region: 'Africa',
    subregion: 'Western Africa',
    supportedIdentityReport: false,
  },
  { name: 'Singapore', alpha3: 'SGP', region: 'Asia', subregion: 'South-Eastern Asia' },
  {
    name: 'Sint Maarten (Dutch part)',
    alpha3: 'SXM',
    region: 'Americas',
    subregion: 'Caribbean',
    supportedIdentityReport: false,
  },
  { name: 'Slovakia', alpha3: 'SVK', region: 'Europe', subregion: 'Eastern Europe' },
  { name: 'Slovenia', alpha3: 'SVN', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Solomon Islands', alpha3: 'SLB', region: 'Oceania', subregion: 'Melanesia', supportedIdentityReport: false },
  { name: 'Somalia', alpha3: 'SOM', region: 'Africa', subregion: 'Eastern Africa' },
  {
    name: 'South Africa',
    alpha3: 'ZAF',
    region: 'Africa',
    subregion: 'Southern Africa',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    alpha3: 'SGS',
    region: 'Americas',
    subregion: 'South America',
    supportedIdentityReport: false,
  },
  {
    name: 'South Sudan',
    alpha3: 'SSD',
    region: 'Africa',
    subregion: 'Northern Africa',
    supportedIdentityReport: false,
  },
  { name: 'Spain', alpha3: 'ESP', region: 'Europe', subregion: 'Southern Europe' },
  { name: 'Sri Lanka', alpha3: 'LKA', region: 'Asia', subregion: 'Southern Asia' },
  { name: 'Sudan', alpha3: 'SDN', region: 'Africa', subregion: 'Northern Africa' },
  { name: 'Suriname', alpha3: 'SUR', region: 'Americas', subregion: 'South America', supportedIdentityReport: false },
  {
    name: 'Svalbard and Jan Mayen',
    alpha3: 'SJM',
    region: 'Europe',
    subregion: 'Northern Europe',
    supportedIdentityReport: false,
  },
  { name: 'Sweden', alpha3: 'SWE', region: 'Europe', subregion: 'Northern Europe' },
  { name: 'Switzerland', alpha3: 'CHE', region: 'Europe', subregion: 'Western Europe' },
  {
    name: 'Syrian Arab Republic',
    alpha3: 'SYR',
    region: 'Asia',
    subregion: 'Western Asia',
  },
  {
    name: 'Taiwan, Province of China',
    alpha3: 'TWN',
    region: 'Asia',
    subregion: 'Eastern Asia',
  },
  { name: 'Tajikistan', alpha3: 'TJK', region: 'Asia', subregion: 'Central Asia' },
  {
    name: 'Tanzania, United Republic of',
    alpha3: 'TZA',
    region: 'Africa',
    subregion: 'Eastern Africa',
  },
  { name: 'Thailand', alpha3: 'THA', region: 'Asia', subregion: 'South-Eastern Asia' },
  {
    name: 'Timor-Leste',
    alpha3: 'TLS',
    region: 'Asia',
    subregion: 'South-Eastern Asia',
    supportedIdentityReport: false,
  },
  { name: 'Togo', alpha3: 'TGO', region: 'Africa', subregion: 'Western Africa' },
  { name: 'Tokelau', alpha3: 'TKL', region: 'Oceania', subregion: 'Polynesia', supportedIdentityReport: false },
  { name: 'Tonga', alpha3: 'TON', region: 'Oceania', subregion: 'Polynesia', supportedIdentityReport: false },
  {
    name: 'Trinidad and Tobago',
    alpha3: 'TTO',
    region: 'Americas',
    subregion: 'Caribbean',
  },
  { name: 'Tunisia', alpha3: 'TUN', region: 'Africa', subregion: 'Northern Africa' },
  { name: 'Turkey', alpha3: 'TUR', region: 'Asia', subregion: 'Western Asia' },
  { name: 'Turkmenistan', alpha3: 'TKM', region: 'Asia', subregion: 'Central Asia' },
  {
    name: 'Turks and Caicos Islands',
    alpha3: 'TCA',
    region: 'Americas',
    subregion: 'Caribbean',
  },
  { name: 'Tuvalu', alpha3: 'TUV', region: 'Oceania', subregion: 'Polynesia' },
  { name: 'Uganda', alpha3: 'UGA', region: 'Africa', subregion: 'Eastern Africa' },
  { name: 'Ukraine', alpha3: 'UKR', region: 'Europe', subregion: 'Eastern Europe' },
  {
    name: 'United Arab Emirates',
    alpha3: 'ARE',
    region: 'Asia',
    subregion: 'Western Asia',
  },
  {
    name: 'United Kingdom',
    alpha3: 'GBR',
    region: 'Europe',
    subregion: 'Northern Europe',
  },
  {
    name: 'United States Minor Outlying Islands',
    alpha3: 'UMI',
    region: 'Americas',
    subregion: 'Northern America',
    supportedIdentityReport: false,
  },
  {
    name: 'United States of America',
    alpha3: 'USA',
    region: 'Americas',
    subregion: 'Northern America',
  },
  { name: 'Uruguay', alpha3: 'URY', region: 'Americas', subregion: 'South America', supportedIdentityReport: false },
  { name: 'Uzbekistan', alpha3: 'UZB', region: 'Asia', subregion: 'Central Asia' },
  { name: 'Vanuatu', alpha3: 'VUT', region: 'Oceania', subregion: 'Melanesia' },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    alpha3: 'VEN',
    region: 'Americas',
    subregion: 'South America',
  },
  { name: 'Viet Nam', alpha3: 'VNM', region: 'Asia', subregion: 'South-Eastern Asia' },
  {
    name: 'Virgin Islands (British)',
    alpha3: 'VGB',
    region: 'Americas',
    subregion: 'Caribbean',
  },
  {
    name: 'Virgin Islands (U.S.)',
    alpha3: 'VIR',
    region: 'Americas',
    subregion: 'Caribbean',
    supportedIdentityReport: false,
  },
  {
    name: 'Wallis and Futuna',
    alpha3: 'WLF',
    region: 'Oceania',
    subregion: 'Polynesia',
    supportedIdentityReport: false,
  },
  {
    name: 'Western Sahara',
    alpha3: 'ESH',
    region: 'Africa',
    subregion: 'Northern Africa',
    supportedIdentityReport: false,
  },
  { name: 'Yemen', alpha3: 'YEM', region: 'Asia', subregion: 'Western Asia', supportedIdentityReport: false },
  { name: 'Zambia', alpha3: 'ZMB', region: 'Africa', subregion: 'Eastern Africa' },
  { name: 'Zimbabwe', alpha3: 'ZWE', region: 'Africa', subregion: 'Eastern Africa' },
  { name: 'eSwatini', alpha3: 'SWZ', region: 'Africa', subregion: 'Southern Africa', supportedIdentityReport: false },
  {
    name: 'Åland Islands',
    alpha3: 'ALA',
    region: 'Europe',
    subregion: 'Northern Europe',
  },
] as const;

export type CountryCode = (typeof countries)[number]['alpha3'];
export type Country = Pick<(typeof countries)[number], 'name' | 'alpha3'>;

export default countries;
